export const formatAutoDiscountTitle = (title: string) => {
  const saleMatch = /(midsale|season[- ]?off)\s+\d+%/i.exec(title);
  if (!saleMatch) return title;

  const comboMatch = /(midsale|season[- ]?off)\s+\d+%\s*\+\s*([^,]+)/i.exec(title);
  const memberDiscountText = comboMatch?.[2]?.trim();

  return memberDiscountText ? `${saleMatch[0]}, ${memberDiscountText}` : saleMatch[0];
};
